import React, { useState, useEffect, useContext } from 'react';
import firebase from '../firebase';
import { CurrentContext } from './CurrentContext';
import { Link } from 'react-router-dom';
import useIsOnline from '../hooks/useIsOnline';
import LostConnection from './LostConnection';
import { formatDistanceToNow } from 'date-fns';
import { TrailContext } from './TrailContext';

export default function Displaydata(props) {

    const [trails,] = useContext(TrailContext);
    const docName = trails.find(trail => {
        if(trail.url === props.match.params.trail) {
            return true;
        } else {
            return false;
        }
    }).name;

    const isOnline = useIsOnline();

    const [trail, setTrail] = useState({})
    const [,setCurrent] = useContext(CurrentContext);

    useEffect(() => {
        const db = firebase.firestore();
        const docRef = db.collection('trails').doc(docName);
        const unsubscribe = docRef
            .onSnapshot(doc => {
                setTrail(doc.data());
                setCurrent(doc.data());
                console.log(doc.data())
            })
        return (() => {
            unsubscribe();
        })
    }, [docName, setCurrent]);

    if(!isOnline) {
        return(
            <LostConnection />
        )
    }
    
    return (
        <div className="page">
            <div className="heading">
                {trail && trail.name && <h1 className="headingTitle">{trail.name}</h1>}
                <Link to={`/trails/${props.match.params.trail}/report`} className="headingButton" style={{textDecoration: 'none', color: 'black'}}>Make a Report</Link>
            </div>
            <h3 className="pastReports">Most Recent Report:</h3>
            <div className="reportsGrid">
                {trail && trail.status && <div className="currentData report">
                    <p>Status: {trail.status}/10</p>
                    {typeof(trail.time) === 'string' && <p>Time: {trail.time}</p>}
                    {typeof(trail.time) === 'number' && <p>Time: {formatDistanceToNow(trail.time)} ago</p>}
                </div>}
            </div>
           <h3 className="pastReports">Past Reports:</h3>
           <div className="reportsGrid secondReportsGrid">
               {trail && trail.pastReports && trail.pastReports.map((report, i) => (                
                   <> 
                       {i !== 0 && (
                           <div className="report" key={Math.random() * 10}>
                                <p>Status: {report.status}/10</p>
                                {typeof(report.time) === 'string' && <p>Time: {report.time}</p>}
                                {typeof(report.time) === 'number' && <p>Time: {formatDistanceToNow(report.time)} ago</p>}
                            </div>)
                        }
                    </>
                ))}
            </div>
        </div>
    )
}